import './CostCode.css';
import React, { useState, useEffect } from 'react';

import CostCodeService from '../Services/CostCodeService.js';
import Logo from '../refs/CornerstoneColor.jpg';
import { TbArrowBearRight,TbArrowNarrowRight  } from "react-icons/tb";


const CostCode = () => {
    const [costCode, setCostCode] = useState('');
    const [ oldToNew, setOldToNew ] = useState(null);
    let previousOldKey = -1;
    const [ NewToOld, setNewToOld ] = useState(null);
    let previousNewKey = -1;
    const [ costCodeError, setCostCodeError ] = useState('');

    const CostCodeComparisonComponent = ({firstCostCode,secondCostCode, duplicate}) => {    
        return(
            <div className='Cost-Code-Comparison-Component'>
                <div className='Cost-Code-Comparison-Segment'>
                    {firstCostCode}
                </div>
                {   !duplicate &&
                <>
                    <TbArrowNarrowRight className='Cost-Code-Comparison-Icon'/>
                    <div className='Cost-Code-Comparison-Segment'>
                        {secondCostCode}
                    </div>
                    
                </>
                }
                {   duplicate &&
                <>
                    <div className='Cost-Code-Comparison-Segment-No-Match'>
                    </div>
                    <TbArrowBearRight className='Cost-Code-Comparison-Icon'/>
                </>

                }
            </div>
        )
    };

    const handleCostCodeSubmit = async () => {
        await CostCodeService.getCostCodeResults(costCode).then( response => {
            if(response.status > 199 && response.status < 300){
                console.log(response.data)
                if(response.data.oldToNewCostCodeList) setOldToNew(response.data.oldToNewCostCodeList);
                if(response.data.newToOldCostCodeList) setNewToOld(response.data.newToOldCostCodeList);
            }
            else{
                setCostCodeError('Server Failed to Fetch Cost Code Records. Please contact kbostelman@cornerstoneinc.com for support.');
            }
        })
    };

    useEffect(() => {
        if (costCode) {
            handleCostCodeSubmit();
        };
    }, [costCode]);

    return (
        <div className="Cost-Code-Container">
            <div className="Cost-Code-Form">
                <img src={Logo} className='External-Form-Logo' alt='Cornerstone Logo'/>
                <div className='Cost-Code-Container-Label'>Cost Code Lookup</div>
                {   !oldToNew &&
                    <div className='Cost-Code-Container-Instructions'>Begin by tying in a cost code below</div>
                }
                
                <input onChange={(e) => setCostCode(e.target.value)} type="text" id="costCode" name="costCode" className='Cost-Code-Input' required />

                <div className="Cost-Code-Results-Window">
                    {   !costCodeError && oldToNew &&
                    <>
                        
                        <div className='Cost-Code-Comparison'>
                            <div className='Cost-Code-Comparison-Title'>Old To New Mapping</div>
                            <div className='Cost-Code-Comparison-Results'>
                                {   
                                    Object.keys(oldToNew).map((oldKey,key) => {
                                        let duplicate = false;

                                        if(oldToNew[oldKey] === previousOldKey) duplicate = true;
                                        else previousOldKey = oldToNew[oldKey];

                                        return(
                                            <CostCodeComparisonComponent key={key} firstCostCode={oldKey} secondCostCode={oldToNew[oldKey]} duplicate={duplicate}/>

                                        );
                                    })
                                }
                            </div>
                        </div>
                    </>

                    }
                    {   !costCodeError && NewToOld &&
                        <div className='Cost-Code-Comparison'>
                            <div className='Cost-Code-Comparison-Title'>New To Old Mapping</div>
                            <div className='Cost-Code-Comparison-Results'>
                            {   
                                Object.keys(NewToOld).map((oldKey,key) => {
                                    let duplicate = false;

                                    if(NewToOld[oldKey] === previousNewKey) duplicate = true;
                                    else previousNewKey = NewToOld[oldKey];

                                    return(
                                        <CostCodeComparisonComponent key={key} firstCostCode={oldKey} secondCostCode={NewToOld[oldKey]} duplicate={duplicate}/>

                                    );
                                })
                            }
                            </div>
                    </div>
                    }
                    {   costCodeError &&
                        <div className='Cost-Code-Error'>
                            {costCodeError}
                        </div>
                    }
                </div>
            </div>
        </div>
    );

};

export default CostCode;